// redux/slices/adminSlice.js

import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  adminLoginApi,
} from "../../api/adminAuthApi";

// Login
export const adminLogin =
  createAsyncThunk(
    "admin/login",
    async (data, { rejectWithValue }) => {
      try {
        const response =
          await adminLoginApi(data);

        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data ||
            error.message
        );
      }
    }
  );

// const initialState = {
//   admin: null,
//   loading: false,
//   error: null,
//   isAuthenticated: false,
// };

const adminData =
  localStorage.getItem("admin");

const initialState = {
  admin: adminData
    ? JSON.parse(adminData)
    : null,

  isAuthenticated:
    !!adminData,

  loading: false,
  error: null,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,

//   reducers: {
//     clearAdminError: (state) => {
//       state.error = null;
//     },

//     adminLogoutSuccess: (state) => {
//       state.admin = null;
//       state.isAuthenticated = false;
//     },
//   },
reducers: {
  clearAdminError: (state) => {
    state.error = null;
  },

  adminLogoutSuccess: (state) => {
    state.admin = null;
    state.isAuthenticated = false;
    state.error = null;

    localStorage.removeItem("admin");
  },
},
  extraReducers: (builder) => {
    builder

      // LOGIN
      .addCase(
        adminLogin.pending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )

    //   .addCase(
    //     adminLogin.fulfilled,
    //     (state, action) => {
    //       state.loading = false;
    //       state.isAuthenticated = true;
    //       state.admin =
    //         action.payload.user;
    //     }
    //   )

      .addCase(
  adminLogin.fulfilled,
  (state, action) => {
    state.loading = false;
    state.isAuthenticated = true;
    state.admin = action.payload.user;

    localStorage.setItem(
      "admin",
      JSON.stringify(
        action.payload.user
      )
    );
  }
)

      .addCase(
        adminLogin.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            action.payload?.message ||
            "Login Failed";
        }
      );
  },
});

export const {
  clearAdminError,
  adminLogoutSuccess,
} = adminSlice.actions;

export default adminSlice.reducer;